import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../image/morshed.png";
import "./Navbar.css";

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [color, setColor] = useState(false);

  const handleClick = () => {
    setClick(!click);
  };

  const changeColor = () => {
    if (window.scrollY >= 50) {
      setColor(true);
    } else {
      setColor(false);
    }
  };
  window.addEventListener("scroll", changeColor);
  return (
    <div>
      <header
        className={click === true ? "header active" : "header"}
        id={color ? "sticky header" : "header"}
      >
        <Link to="/" className="logo">
          <img src={logo} alt="logo" />
        </Link>

        <nav className={click === true ? "navbar active" : "navbar"}>
          <Link className="link-button" to="/">
            <div className="hover-underline-animation">Home</div>
          </Link>
          <Link className="link-button" to="/about">
            <div className="hover-underline-animation">About</div>
          </Link>
          <Link className="link-button" to="/works">
            <div className="hover-underline-animation">Works</div>
          </Link>
          <Link className="link-button" to="/blog">
            <div className="hover-underline-animation">Blog</div>
          </Link>
          <Link className="link-button" to="/Contacts_us">
            <div className="hover-underline-animation">Contacts</div>
          </Link>
          {/* <a
            href="https://drive.google.com/file/d/1ehRki9yivekcqZm7oUREwWvE_s9vRnPd/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            My Resume
          </a> */}
        </nav>

        <div
          id="menu-btn"
          onClick={handleClick}
          className={
            click === true
              ? "fa-solid fa-bars fa-2x fa-times"
              : "fa-solid fa-bars fa-2x"
          }
        ></div>
      </header>
    </div>
  );
};

export default Navbar;
